<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4a6.26 6.26 0 016.24 6.26c0 2.19-3.31 6.41-6.24 9.41-2.93-3-6.24-7.22-6.24-9.41A6.26 6.26 0 0112 4m0-2a8.25 8.25 0 00-8.24 8.26c0 3.74 5.55 9.56 7.54 11.53a1 1 0 001.4 0c2-2 7.54-7.79 7.54-11.53A8.25 8.25 0 0012 2z"/><path d="M15.24 9.2l-1.75-1.74-1.07-1.08a.6.6 0 00-.83 0l-1.07 1.08L8.77 9.2 8 10a.58.58 0 00.41 1h7.16a.58.58 0 00.43-1z"/></svg>